import { JwtInfo } from '#common/schemas/eua.schema';

/**
 * Converts string fields to normalized key/value pairs for telemetry contexts.
 * Non-string values and excluded keys are skipped.
 */
export const normalizeJwtContext = (jwt: JwtInfo): Record<string, string> => {
  const context: Record<string, string> = {};

  Object.entries(jwt).forEach(([rawKey, value]) => {
    const key = rawKey;
    if (typeof value === 'string') context[key] = value.toLowerCase().trim();
  });

  return context;
};
